import type { ServerResponse } from "http";
import { serialize, CookieSerializeOptions } from "cookie";

const setCookie = (
  res: ServerResponse,
  name: string,
  value: string | Record<string, unknown>,
  options: CookieSerializeOptions = {},
) => {
  const stringValue =
    typeof value === "object" ? `j:${JSON.stringify(value)}` : String(value);

  const optionsCopy = options;

  if (options.maxAge !== undefined) {
    optionsCopy.expires = new Date(Date.now() + options.maxAge);
    optionsCopy.maxAge = options.maxAge / 1000;
  }

  res.setHeader(
    "Set-Cookie",
    serialize(name, String(stringValue), optionsCopy),
  );
};

export { setCookie };
